import { compose } from 'redux'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import { applyFilter } from '../actions'
import BrandRefinementMenu from './BrandRefinementMenu'

export default compose(
  withType({ type: ['BrandRefinementMenu', 'BOTBrandRefinementMenu', 'BOTNonCompatibleBrandRefinementMenu']}),
  connect(null, { applyFilter })
)(BrandRefinementMenu)
